import { render, staticRenderFns } from "./fit-text.vue?vue&type=template&id=af289dc8&lang=pug&"
import script from "./fit-text.vue?vue&type=script&lang=js&"
export * from "./fit-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports